import React from 'react';
import ModulePageFrame from '../../custom-modules/components/module-page-frame';

export default function StoreChatbotConfiguration() {
  return <ModulePageFrame page="chatbot-configuration" />;
}
